/**
 * @description 灰度节点配置 ABNodeConfig
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const ABNodeConfigBiz = new Logic()

ABNodeConfigBiz.deleteNode = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABNodeConfig.deleteNode,
    data: data
  })
}

ABNodeConfigBiz.releaseNode = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABNodeConfig.releaseNode,
    data: data
  })
}

ABNodeConfigBiz.createNode = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABNodeConfig.createNode,
    data: data
  })
}

ABNodeConfigBiz.findNode = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ABNodeConfig.findNode,
    data: data
  })
}

export default ABNodeConfigBiz
